/**
 * 部门架构列表
 *
 * @export
 * @interface IDepartmentItem
 */
export interface IDepartmentItem {
  /** 部门uuid */
  uuid: string;
  /** 部门名称 */
  name: string;
  /** 父级部门uuid */
  parent: string | null;
  /** 部门描述 */
  description: string;
  /** 是否有职员关联(暂时无用) */
  has_staff?: boolean;
}

/**
 * 部门架构列表查询参数
 *
 * @export
 * @interface IDepartmentQuery
 */
export interface IDepartmentQuery {
  /** 上级部门uuid */
  parent?: string;
  limit?: number;
  offset?: number
}

/**
 * 通用字典数据类型
 * @export
 * @interface IDict
 */
export interface IDict {
  value: boolean | number | string;
  name: string;
  key: string;
}

/**
 * 职员查询搜索条件
 * @export
 * @interface IStaffSearch
 */
export class IStaffSearch {
  /** 本部门以及子部门uuid, 逗号分隔 */
  // tslint:disable-next-line:variable-name
  department__in: string | undefined;
  /** 本部门uuid */
  department: string | undefined;
  /** 邀请码 */
  code: string | undefined;
  /** 姓名 */
  fullname: string | undefined;
  /** 手机号 */
  mobile: string | undefined;
  /** 职员角色 */
  role: StaffRoles | undefined;
  /** 启用状态 */
  // tslint:disable-next-line:variable-name
  is_active: boolean | undefined;
  limit: number;
  offset: number;
  constructor(limit: number) {
    this.department = undefined;
    this.department__in = undefined;
    this.code = undefined;
    this.fullname = undefined;
    this.mobile = undefined;
    this.role = undefined;
    this.is_active = undefined;
    this.offset = 0;
    this.limit = limit;
  }
}

/**
 * 职员详情
 * @export
 * @interface IStaffSearch
 */
export interface IStaffDetail {
  index?: number;
  /** 职员uuid */
  uuid: string;
  /** 职员工号 */
  code: string;
  /** 所属部门uuid */
  department: string;
  /** 用户名 */
  username: string;
  /** 姓名 */
  fullname: string;
  /** 初始密码 */
  password: string;
  /** 手机号 */
  mobile: string;
  /** 职员角色 */
  role: StaffRoles;
  /** 启用状态 */
  is_active: boolean;
  /** 数据权限 */
  data_auth: StaffAuths;
  /** 邮箱 */
  email: string;
}

/**
 * 职员角色枚举
 * @export
 * @interface StaffRoles
 */
export enum StaffRoles {
  /** 管理员 */
  Admin = 'Admin',
  /** 操作员 */
  Assist = 'Assist',
  /** 销售员 */
  Salesman = 'Salesman',
}

/**
 * 职员数据权限枚举
 * @export
 * @interface StaffAuths
 */
export enum StaffAuths {
  /** 本人 */
  Individual = 'MEM',
  /** 本部门 */
  Department = 'DEP',
  /** 全公司 */
  Institution = 'INS',
}




// WEBPACK FOOTER //
// ./src/entity/DepartmentEntity.ts